/** Shared social / Open Graph constants (used by middleware + app metadata). */
export const SOCIAL_SHARE = {
  siteUrl: "https://doimpo.com",
  title: "doimpo - You Focus on Growth. We Handle the Rest.",
  description:
    "Strategy, brand, product, and marketing under one roof for teams in the US, UK, AU, and UAE. One partner. No vendor juggling.",
  /** Primary share image — JPEG for maximum crawler compatibility. */
  imagePath: "/media/brand/og-doimpo-collab.jpg",
  imageUrl: "https://doimpo.com/media/brand/og-doimpo-collab.jpg",
  imageAlt: "doimpo collab — You focus on growth. We handle the rest.",
  imageWidth: 1200,
  imageHeight: 630,
} as const;

const BOT_PATTERN =
  /LinkedInBot|linkedinbot|facebookexternalhit|Facebot|Twitterbot|Slackbot|WhatsApp|TelegramBot|Discordbot|Pinterest|Embedly|vkShare|SkypeUriPreview|nuzzel|redditbot|quora link preview|outbrain|Slack-ImgProxy|iframely|Upwork/i;

export function isSocialPreviewBot(userAgent: string | null): boolean {
  if (!userAgent) return false;
  return BOT_PATTERN.test(userAgent);
}

/** Fallback OG HTML when path-aware builder is unavailable. */
export function buildSocialBotHtml(canonicalUrl: string = SOCIAL_SHARE.siteUrl): string {
  const s = SOCIAL_SHARE;
  const esc = (value: string) =>
    value
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");

  return `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <title>${esc(s.title)}</title>
    <meta name="description" content="${esc(s.description)}" />
    <link rel="canonical" href="${esc(canonicalUrl)}" />
    <link rel="image_src" href="${esc(s.imageUrl)}" />
    <meta property="og:title" content="${esc(s.title)}" />
    <meta property="og:description" content="${esc(s.description)}" />
    <meta property="og:url" content="${esc(canonicalUrl)}" />
    <meta property="og:site_name" content="doimpo" />
    <meta property="og:type" content="website" />
    <meta property="og:image" content="${esc(s.imageUrl)}" />
    <meta property="og:image:secure_url" content="${esc(s.imageUrl)}" />
    <meta property="og:image:type" content="image/jpeg" />
    <meta property="og:image:width" content="${s.imageWidth}" />
    <meta property="og:image:height" content="${s.imageHeight}" />
    <meta property="og:image:alt" content="${esc(s.imageAlt)}" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="${esc(s.title)}" />
    <meta name="twitter:description" content="${esc(s.description)}" />
    <meta name="twitter:image" content="${esc(s.imageUrl)}" />
    <meta name="twitter:image:alt" content="${esc(s.imageAlt)}" />
  </head>
  <body>
    <h1>${esc(s.title)}</h1>
    <p>${esc(s.description)}</p>
  </body>
</html>`;
}
